import React from 'react'
import './Footer.css'
import Facebook from '../../images/facebook.png'
import Insta from '../../images/insta.png'
import Youtube from '../../images/youtube.png'
import Twitter from '../../images/twitter.png'
import Telegram from '../../images/telegram.png'

function Footer() {
    return (
        <div className="container-fluid has-bg-img">
            <div className="center col-md-6 d-flex justify-content-between">
               <a href="#"><img src={Facebook} className="footer_social" /></a>
               <a href="#"><img src={Insta} className="footer_social" /></a>
               <a href="#"><img src={Youtube} className="footer_social" /></a>
               <a href="#"><img src={Twitter} className="footer_social" /></a>
               <a href="#"><img src={Telegram} className="footer_social" /></a>
            </div>

            <div className="center col-md-4 d-flex justify-content-between mt-2">
               <a href="#" className="text-black fw-bold footer_text">Calculator</a>
               <a href="#" className="text-black fw-bold footer_text">Whitepaper</a>
               <a href="#" className="text-black fw-bold footer_text">FAQs</a>
            </div>

            <div id="bottom" className="center d-flex col-md-4 mt-3 justify-content-center">
                <p className="text-black footer-text">ShitFace Inu © Inu All right reserved</p>
            </div>
        </div>
    )
}

export default Footer
